class CustomVariantSelector {
  constructor() {
    this.init();
    this.bindEvents();
  }

  init() {
    this.initCustomSelects();
  }

  bindEvents() {
    document.addEventListener('click', this.closeAllSelect.bind(this));
    document.addEventListener('shopify:section:load', () => this.initCustomSelects());
    document.addEventListener('shopify:block:select', () => this.initCustomSelects());
  }

  initCustomSelects() {
    const customSelects = document.getElementsByClassName("custom-select");
    
    Array.from(customSelects).forEach(wrapper => {
      // Clear existing custom UI elements if any
      const existingSelected = wrapper.querySelector('.select-selected');
      const existingItems = wrapper.querySelector('.select-items');
      if (existingSelected) existingSelected.remove();
      if (existingItems) existingItems.remove();

      const select = wrapper.getElementsByTagName("select")[0];
      if (!select) return;

      // Create custom selected item
      const selectedOption = document.createElement("DIV");
      selectedOption.setAttribute("class", "select-selected");
      selectedOption.innerHTML = select.options[select.selectedIndex].innerHTML;
      wrapper.appendChild(selectedOption);

      // Create custom options list
      const optionsList = document.createElement("DIV");
      optionsList.setAttribute("class", "select-items select-hide");

      // Include all options, including the first one
      Array.from(select.options).forEach((option, index) => {        
        const optionDiv = document.createElement("DIV");
        optionDiv.innerHTML = option.innerHTML;
        optionDiv.setAttribute('data-value', option.value);
        
        // Mark selected option
        if (index === select.selectedIndex) {
          optionDiv.setAttribute("class", "same-as-selected");
        }

        optionDiv.addEventListener("click", (e) => {
          const originalSelect = wrapper.getElementsByTagName("select")[0];
          const selectedDisplay = optionDiv.parentNode.previousSibling;

          // Update native select and trigger change event
          originalSelect.value = optionDiv.getAttribute('data-value');
          originalSelect.dispatchEvent(new Event('change', { bubbles: true }));

          // Update custom UI
          selectedDisplay.innerHTML = optionDiv.innerHTML;
          
          // Update selected styling
          const siblings = optionDiv.parentNode.getElementsByTagName("div");
          Array.from(siblings).forEach(sib => sib.removeAttribute("class"));
          optionDiv.setAttribute("class", "same-as-selected");

          // Close dropdown
          selectedDisplay.click();
        });

        optionsList.appendChild(optionDiv);
      });

      wrapper.appendChild(optionsList);

      // Add click handler to selected item
      selectedOption.addEventListener("click", (e) => {
        e.stopPropagation();
        this.closeAllSelect(selectedOption);
        selectedOption.nextSibling.classList.toggle("select-hide");
        selectedOption.classList.toggle("select-arrow-active");
      });
    });
  }

  closeAllSelect(elmnt) {
    const selectItems = document.getElementsByClassName("select-items");
    const selectedItems = document.getElementsByClassName("select-selected");
    const arrNo = [];

    Array.from(selectedItems).forEach((item, index) => {
      if (elmnt === item) {
        arrNo.push(index);
      } else {
        item.classList.remove("select-arrow-active");
      }
    });

    Array.from(selectItems).forEach((item, index) => {
      if (!arrNo.includes(index)) {
        item.classList.add("select-hide");
      }
    });
  }
}

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', () => {
  window.customVariantSelector = new CustomVariantSelector();
});